"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.subscribeToProductsWarehouses = exports.deleteProductRealTime = exports.editProductRealTime = exports.addProductRealTime = exports.editProduct = exports.deleteProduct = exports.addProduct = exports.fetchProductById = exports.fetchProductsByWarehouseId = exports.fetchProductsBySearch = exports.fetchProductsInBatches = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var supabaseClient_1 = require("../../supabaseClient"); // Adjust the import path as needed
var initialState = {
    data: [],
    product: {},
    status: "idle",
    error: null,
    globalProductsData: {},
    loaded: false,
};
// Fetch all products in batches
exports.fetchProductsInBatches = (0, toolkit_1.createAsyncThunk)("products_warehouses/fetchProductsInBatches", function (_, _a) {
    var rejectWithValue = _a.rejectWithValue;
    return __awaiter(void 0, void 0, void 0, function () {
        var _b, data, error;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, supabaseClient_1.supabase
                        .from("products_warehouses")
                        .select("*")];
                case 1:
                    _b = _c.sent(), data = _b.data, error = _b.error;
                    if (error) {
                        return [2 /*return*/, rejectWithValue(error.message)];
                    }
                    return [2 /*return*/, data];
            }
        });
    });
});
// Fetch all products in batches
exports.fetchProductsBySearch = (0, toolkit_1.createAsyncThunk)("products_warehouses/fetchProductsBySearch", function (_a, _b) {
    var name = _a.name, description = _a.description, limit = _a.limit, active = _a.active;
    var rejectWithValue = _b.rejectWithValue;
    return __awaiter(void 0, void 0, void 0, function () {
        var query, _c, data, error;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    query = supabaseClient_1.supabase.from("products_warehouses").select("*");
                    // Add conditions dynamically based on non-empty inputs
                    if (name) {
                        query = query.ilike("name", "%".concat(name, "%"));
                    }
                    if (description) {
                        query = query.ilike("description", "%".concat(description, "%"));
                    }
                    if (active) {
                        query = query.eq("active", active);
                    }
                    // Limit the number of results
                    query = query.limit(limit);
                    return [4 /*yield*/, query];
                case 1:
                    _c = _d.sent(), data = _c.data, error = _c.error;
                    // const { data, error } = await supabase
                    //   .from("products_warehouses")
                    //   .select("*")
                    //   .or(`name.ilike.%${searchTerm}%,description.ilike.%${searchTerm}%`) // Search on both columns
                    //   .limit(100); // Limit the results to 20 for performance
                    if (error) {
                        console.error("Error fetching products:", error.message);
                        return [2 /*return*/, []];
                    }
                    return [2 /*return*/, data];
            }
        });
    });
});
// Fetch products by warehouse ID
exports.fetchProductsByWarehouseId = (0, toolkit_1.createAsyncThunk)("products_warehouses/fetchProductsByWarehouseId", function (warehouseId, thunkApi) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, data, error;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, supabaseClient_1.supabase
                    .from("products_warehouses")
                    .select("*")
                    .eq("warehouseId", warehouseId)];
            case 1:
                _a = _b.sent(), data = _a.data, error = _a.error;
                if (error) {
                    return [2 /*return*/, thunkApi.rejectWithValue(error.message)];
                }
                return [2 /*return*/, data];
        }
    });
}); });
// Fetch product by id
exports.fetchProductById = (0, toolkit_1.createAsyncThunk)("products_warehouses/fetchProductById", function (productId, thunkApi) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, data, error;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, supabaseClient_1.supabase
                    .from("products_warehouses")
                    .select("*")
                    .eq("id", productId)
                    .single()];
            case 1:
                _a = _b.sent(), data = _a.data, error = _a.error;
                if (error) {
                    return [2 /*return*/, thunkApi.rejectWithValue(error.message)];
                }
                return [2 /*return*/, data];
        }
    });
}); });
// Add a new product
exports.addProduct = (0, toolkit_1.createAsyncThunk)("products_warehouses/addProduct", function (newProduct, thunkApi) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, insertData, insertError;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, supabaseClient_1.supabase
                    .from("products_warehouses")
                    .insert(newProduct)
                    .select()
                    .single()];
            case 1:
                _a = _b.sent(), insertData = _a.data, insertError = _a.error;
                console.log({ insertData: insertData, insertError: insertError });
                if (insertError) {
                    return [2 /*return*/, thunkApi.rejectWithValue(insertError.message)];
                }
                return [2 /*return*/, insertData];
        }
    });
}); });
// Delete a product
exports.deleteProduct = (0, toolkit_1.createAsyncThunk)("products_warehouses/deleteProduct", function (id, thunkApi) { return __awaiter(void 0, void 0, void 0, function () {
    var error;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, supabaseClient_1.supabase
                    .from("products_warehouses")
                    .delete()
                    .eq("id", id)];
            case 1:
                error = (_a.sent()).error;
                if (error) {
                    return [2 /*return*/, thunkApi.rejectWithValue(error.message)];
                }
                return [2 /*return*/, id];
        }
    });
}); });
// Edit a product
exports.editProduct = (0, toolkit_1.createAsyncThunk)("products_warehouses/editProduct", function (updatedProduct, thunkApi) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, updateData, updateError;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, supabaseClient_1.supabase
                    .from("products_warehouses")
                    .update(updatedProduct)
                    .eq("id", updatedProduct.id)
                    .select()
                    .single()];
            case 1:
                _a = _b.sent(), updateData = _a.data, updateError = _a.error;
                if (updateError) {
                    return [2 /*return*/, thunkApi.rejectWithValue(updateError.message)];
                }
                return [2 /*return*/, updateData];
        }
    });
}); });
// Real-time actions
var addProductRealTime = function (newProduct) { return ({
    type: "products_warehouses/addProductRealTime",
    payload: newProduct,
}); };
exports.addProductRealTime = addProductRealTime;
var editProductRealTime = function (updatedProduct) { return ({
    type: "products_warehouses/editProductRealTime",
    payload: updatedProduct,
}); };
exports.editProductRealTime = editProductRealTime;
var deleteProductRealTime = function (id) { return ({
    type: "products_warehouses/deleteProductRealTime",
    payload: id,
}); };
exports.deleteProductRealTime = deleteProductRealTime;
// Slice definition
var productsWarehousesSlice = (0, toolkit_1.createSlice)({
    name: "products_warehouses",
    initialState: initialState,
    reducers: {
        addProductRealTime: function (state, action) {
            var _a;
            var exists = state.data.some(function (product) { return product.id === action.payload.id; });
            if (!exists) {
                state.data.push(action.payload);
                state.globalProductsData[(_a = action.payload.id) !== null && _a !== void 0 ? _a : ""] = action.payload;
            }
            state.error = null;
        },
        editProductRealTime: function (state, action) {
            var _a;
            var index = state.data.findIndex(function (product) { return product.id === action.payload.id; });
            if (index !== -1) {
                var isDifferent = JSON.stringify(state.data[index]) !== JSON.stringify(action.payload);
                if (isDifferent) {
                    state.data[index] = action.payload;
                }
            }
            state.globalProductsData[(_a = action.payload.id) !== null && _a !== void 0 ? _a : ""] = action.payload;
            state.error = null;
        },
        deleteProductRealTime: function (state, action) {
            var exists = state.data.some(function (product) { return product.id === action.payload; });
            if (exists) {
                state.data = state.data.filter(function (product) { return product.id !== action.payload; });
            }
            delete state.globalProductsData[action.payload];
            state.error = null;
        },
    },
    extraReducers: function (builder) {
        builder
            // fetch all products
            .addCase(exports.fetchProductsInBatches.pending, function (state) {
            state.status = "loading";
        })
            .addCase(exports.fetchProductsInBatches.fulfilled, function (state, action) {
            state.loaded = true;
            action.payload.forEach(function (product) {
                var _a;
                state.globalProductsData[(_a = product.id) !== null && _a !== void 0 ? _a : ""] = product;
            });
        })
            .addCase(exports.fetchProductsInBatches.rejected, function (state, action) {
            state.status = "failed";
            state.error = action.payload || "Failed to fetch products.";
        })
            // fetch search products
            .addCase(exports.fetchProductsBySearch.pending, function (state) {
            state.status = "loading";
        })
            .addCase(exports.fetchProductsBySearch.fulfilled, function (state, action) {
            state.loaded = true;
            state.data = action.payload;
        })
            .addCase(exports.fetchProductsBySearch.rejected, function (state, action) {
            state.status = "failed";
            state.error = action.payload || "Failed to fetch products.";
        })
            // Handle fetchProductsByWarehouseId
            .addCase(exports.fetchProductsByWarehouseId.pending, function (state) {
            state.status = "loading";
        })
            .addCase(exports.fetchProductsByWarehouseId.fulfilled, function (state, action) {
            state.status = "succeeded";
            state.data = action.payload;
            state.error = null;
        })
            .addCase(exports.fetchProductsByWarehouseId.rejected, function (state, action) {
            state.status = "failed";
            state.error =
                action.payload || "Failed to fetch products by warehouse.";
        })
            // Handle fetchProductById
            .addCase(exports.fetchProductById.pending, function (state) {
            state.status = "loading";
        })
            .addCase(exports.fetchProductById.fulfilled, function (state, action) {
            state.status = "succeeded";
            state.product = action.payload;
            state.error = null;
        })
            .addCase(exports.fetchProductById.rejected, function (state, action) {
            state.status = "failed";
            state.error =
                action.payload || "Failed to fetch products by warehouse.";
        })
            // Handle addProduct
            .addCase(exports.addProduct.fulfilled, function (state, action) {
            state.data.push(action.payload);
            state.error = null;
        })
            .addCase(exports.addProduct.rejected, function (state, action) {
            state.error = action.payload || "Failed to add product.";
        })
            // Handle deleteProduct
            .addCase(exports.deleteProduct.fulfilled, function (state, action) {
            state.data = state.data.filter(function (product) { return product.id !== action.payload; });
            state.error = null;
        })
            .addCase(exports.deleteProduct.rejected, function (state, action) {
            state.error = action.payload || "Failed to delete product.";
        })
            // Handle editProduct
            .addCase(exports.editProduct.fulfilled, function (state, action) {
            var index = state.data.findIndex(function (product) { return product.id === action.payload.id; });
            if (index !== -1) {
                state.data[index] = action.payload;
            }
            state.error = null;
        })
            .addCase(exports.editProduct.rejected, function (state, action) {
            state.error = action.payload || "Failed to edit product.";
        });
    },
});
// Real-time subscription function
var subscribeToProductsWarehouses = function (dispatch) {
    var subscription = supabaseClient_1.supabase
        .channel("public:products_warehouses")
        .on("postgres_changes", { event: "*", schema: "public", table: "products_warehouses" }, function (payload) {
        var _a;
        var newRecord = payload.new;
        var oldRecord = payload.old;
        switch (payload.eventType) {
            case "INSERT":
                dispatch((0, exports.addProductRealTime)(newRecord));
                break;
            case "UPDATE":
                dispatch((0, exports.editProductRealTime)(newRecord));
                break;
            case "DELETE":
                dispatch((0, exports.deleteProductRealTime)((_a = oldRecord.id) !== null && _a !== void 0 ? _a : ""));
                break;
            default:
                break;
        }
    })
        .subscribe();
    return function () {
        subscription.unsubscribe();
    };
};
exports.subscribeToProductsWarehouses = subscribeToProductsWarehouses;
exports.default = productsWarehousesSlice.reducer;
